export default __webpack_public_path__ + "static/media/twitter.05b30094.svg";